import '@nike/podium/styles/core.css';
import '@nike/podium/styles/nike/en-us.css';
import React, {useContext} from "react";
import {ToastProvider, ToastViewport} from "@nike/podium";
import SnackbarContext from "./providers/snackbar-context";
import {Route, Routes} from "react-router-dom";
import ApplicationSnackbar from "./components/shared/ApplicationSnackbar";
import {ImbalanceManagement} from "./components/imbalance-management/ImbalanceManagement";

export function App({locationTracker, host, permissions}) {
    const snackbarCtx = useContext(SnackbarContext);

    return (
        <ToastProvider duration={10000}>
            <div>
                <Routes>
                    <Route path="/imbalance-management"
                        element={<ImbalanceManagement />}/>
                    <Route path="*"
                        element={<ImbalanceManagement />}/>
                </Routes>
                {snackbarCtx.isDisplayed && <ApplicationSnackbar/>}
            </div>
            <ToastViewport />
        </ToastProvider>
    );
}

export default App;
